import { useGoogleLogin } from '@react-oauth/google';

export const useConditionalGoogleLogin = (googleClientId, options) => {
    if (!googleClientId) {
        return null;
    }

    return useGoogleLogin(options);
};
